import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { BuscarProfesor } from "../../API/CoreAd";
import FilterField from "./FilterField";
import { Row, Col } from "reactstrap";
import ListaChats from "./ListaChats";
import Mensajes from "./Mensajes";
//import CorreoI from "../CorreosI/nuevo";
import { BuscarChats } from "../../API/CoreAd";
import FeatherIcon from "feather-icons-react";
import moment from "moment";
//componentes
function Chat(props) {
  const [chats, setChats] = React.useState([]);
  const [IdProfesor, setIdProfesor] = React.useState(null);
  const [chatSelected, setChatSelected] = React.useState(null);
  const [refreshChats, setRefreshChats] = React.useState(0);
  const [openvio, setOpenvio] = React.useState("1");
  const [mensaje, setMensaje] = React.useState("");

  const InitData = async () => {
    try {
      // let response = await BuscarCantidadAlumno(props.usuario1.password);
      // console.log("especialista " + props.cedulaEsp);
      // console.log("alumno " + props.cedulaP);
      // console.log("sala " + props.salaP);
      // console.log("nombre especialista " + props.nombreEsp);

      setIdProfesor(props.cedulaEsp);

      setChatSelected({
        id: null,
        profesor: String(props.cedulaEsp),
        alumno: props.cedulaP,
        nombre_alumno: props.nombrePaciente,
        materia: props.salaP,
        // nombre_Especialista: props.nombreEsp,
      });
    } catch (err) {
      console.log(err);
    }
  };

  const InitData2 = async () => {
    try {
      let response = await BuscarChats(
        props.cedulaEsp,
        props.salaP,
        props.cedulaP
      );
      response.data.variable2.map((item, i) => {
        console.log("chat " + item.variable8);
        if (item.variable !== "") {
          setChatSelected({
            id: item.variable,
            profesor: item.variable8,
            alumno: item.variable4,
            nombre_alumno: item.variable5,
            materia: item.variable6,
            // nombre_Especialista: props.nombreEsp,
          });
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  const Seleccionar_Alumno = (alumno) => {
    if (alumno !== null) {
      setChatSelected({
        id: null,
        profesor: String(IdProfesor),
        alumno: alumno.cedula,
        nombre_alumno: alumno.nombre,
        materia: alumno.materia,
      });
    }
  };

  const Seleccionar_Chat = (data) => {
    console.log("data " + data);
    setChatSelected(data);
  };

  const onChange1 = (e) => {
    if (e !== null) {
      setOpenvio(e.target.value);
    }
    //else {
    //   setOpenvio(ne.target.value);
    // }
  };

  React.useEffect(() => {
    InitData();
    InitData2();
  }, []);

  return (
    <div>
      {IdProfesor !== null && (
        <Container>
          <FieldContainer7>
            <TituloChatBlock>
              <Span>Mensajeria Terapias Paciente: {props.nombrePaciente}</Span>
              {props.fechadia && String(props.fechadia).trim() !== "" && (
                <SubFechaCita>
                  Fecha de la cita:{" "}
                  {moment(props.fechadia).format("DD/MM/YYYY")}
                </SubFechaCita>
              )}
            </TituloChatBlock>
          </FieldContainer7>
          <FieldContainer>
            <FieldContainer6>
              <FieldContainer3>
                <label className="">
                  Mensajes
                  <input
                    type="radio"
                    value="1"
                    name="openvio"
                    checked={openvio === "1"}
                    onChange={onChange1}
                  />
                  <span className="checkmark"></span>
                </label>
              </FieldContainer3>
              {/* <FieldContainer5>
                <label className="">
                  Correo
                  <input
                    type="radio"
                    value="2"
                    name="openvio"
                    checked={openvio === "2"}
                    onChange={onChange1}
                  />
                  <span className="checkmark"></span>
                </label>
              </FieldContainer5> */}

              <Salir onClick={props.cerrarLista}>
                <FeatherIcon icon="log-out" stroke="#fff" size="18" />{" "}
              </Salir>
            </FieldContainer6>
          </FieldContainer>
          {openvio === "1" && (
            <MessagesContent>
              <Mensajes
                updatListChats={() => setRefreshChats(refreshChats + 1)}
                selected={chatSelected}
                reporte={props.reporte}
                idasociar={props.idasociar}
                fechadia={props.fechadia}
              />
            </MessagesContent>
          )}
          {/* {openvio === "2" && (
            <MessagesContent>
              <CorreoI
                selected={chatSelected}
              />
            </MessagesContent>
          )} */}
        </Container>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    usuario1: state.usuario1,
    token: state.token,
  };
};

export default connect(mapStateToProps)(Chat);

const Container = styled.div`
  margin-top: 15px;
  height: 80vh;
`;

const Sidebar = styled.aside`
  width: 275px;
  border-right: solid 1px #eee;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  float: left;
`;

const MessagesContent = styled.section`
  width: 100%;
  height: 90%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  float: left;
  background-color: #ecf0f6;
`;
const FieldContainer = styled.div`
  /* width: calc(100% - 275px); */
  width: 100%;
  height: 120px;
  border: 3px solid #d8e1ee;
  align-items: flex-start;
  background-color: #ecf0f6;
`;
const FieldContainer3 = styled.div`
  padding: 10px;
`;
const FieldContainer5 = styled.div`
  padding: 10px;
`;
const FieldContainer6 = styled.div`
  max-width: 100%;
  height: 40px;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  /* background-color: #fff; */
  font-weight: bold;
`;
const FieldContainer7 = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
`;
const TituloChatBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-align: center;
`;
const Span = styled.span`
  padding: 3px;
  font-size: 20px;
  font-weight: bold;
`;
const SubFechaCita = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #028d7b;
`;
const Salir = styled.button`
  border-radius: 3px;
  width: 10%;
  height: 100%;
  border: solid 1px #eee;
  background-color: #028d7b;
  text-align: center;
  transition: all 0.3s;
  :hover {
    opacity: 0.8;
  }
  svg {
    width: 20px;
    stroke: #ffff;
  }
`;
